import React, { useState, useEffect } from 'react';
import Table from '../../Components/table';
import Paginations from '../../Components/Pagination/pagination';
import useLoading from "../../hooks/useLoading";
import { NotificationManager } from 'react-notifications';

import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import { AsyncTypeahead } from "react-bootstrap-typeahead";

import { apiGetActCajas, apiCreateActCajas, apiDeleteActCajas } from "../../lib/apiAdmin";
import { apiGetActividades } from "../../lib/apiSys21";

const ActividadesCajas = () => {

    const [filters, setFilters] = useState({ page: 1, limit: 10, search: "" });
    const [results, setResults] = useState({
        "count": 0,
        "rows": []
    });
    const [form, setForm] = useState({
        "id_actividad": null
    });
    const [typeahead, setTypeahead] = useState({
        isLoading: false,
        options: [],
    });
    const [showCreate, setShowCreate] = useState(false);
    const [showConfirm, setShowConfirm] = useState(false);
    const [id2Delete, setId2Delete] = useState(null);

    const handleSelectedActOnTypeahead = (obj) => {
        let actividad = obj[0];
        setForm({ ...form, id_actividad: obj.length > 0 ? actividad.sys21_id : null });
    };

    const handleCloseCreate = () => {
        setShowCreate(false);
        setForm({
            "id_actividad": null
        });
    };

    const handleShowCreate = () => setShowCreate(true);

    const handleCloseConfirm = () => setShowConfirm(false);

    const handleShowConfirm = (id) => {
        setId2Delete(id);
        setShowConfirm(true);
    };

    const columns = ["ID", "Actividad", ""];

    const loading = useLoading();

    const changeSearch = (e) => {
        setFilters({ ...filters, search: e.target.value });
    }

    const paginationHandleClick = (page) => {
        setFilters({ ...filters, page });
    }

    const limitChange = (limit) => {
        setFilters({ ...filters, limit });
    }

    const createActCajas = () => {
        loading.set();
        apiCreateActCajas(form)
            .then((response) => {
                if (response.error) {
                    NotificationManager.error(response.message, '', 5000);
                } else {
                    NotificationManager.success('Relación a actividad creada correctamente.', '', 5000);
                    setShowCreate(false);
                    setForm({
                        "id_actividad": null
                    });
                    getLstActCajas();
                }
                loading.stop();
            })
            .catch();
    };

    const deleteActCajas = () => {
        loading.set();
        apiDeleteActCajas({ id: id2Delete })
            .then((response) => {
                if (response.error) {
                    NotificationManager.error('Algo falló, favor de intentar más tarde.', '', 5000);
                } else {
                    NotificationManager.success('Relación a actividad eliminada correctamente.', '', 5000);
                    setShowConfirm(false);
                    setId2Delete(null);
                    getLstActCajas();
                }
                loading.stop();
            })
            .catch();
    };

    const getLstActCajas = () => {
        apiGetActCajas(filters)
            .then(response => {
                const act_cajas = { count: response.count, rows: [] };
                for (let act of response.rows) {
                    act_cajas.rows.push({
                        id_actividad: act.id_actividad,
                        nombre: act.actividad.nombre,
                        options: <div className='text-right'><button className="btn btn-lgt btn-danger" onClick={() => handleShowConfirm(act.id_actividad)}><i className="fas fa-trash" /></button></div>
                    });
                }
                setResults(act_cajas);
            })
            .catch(error => {
                console.error("ERROR en getLstActCajas", error);
            })
    };

    useEffect(() => {
        getLstActCajas();
    }, [filters]);

    const searchActividad = (search) => {
        apiGetActividades({ search, limit: 7 })
            .then((response) => {
                if (response.error) {
                } else {
                    setTypeahead({
                        isLoading: false,
                        options: response.rows.map((act) => ({
                            ...act,
                            id_nombre: act.sys21_id + " - " + act.nombre,
                        })),
                    });
                }
            })
            .catch();
    };

    return (
        <div className='mt-3'>
            <div className="card separate">
                <div className="card-body">
                    <div className="mb-3 form-inline">
                        <div className='col-md-6'>
                            <input className="form-control limit" placeholder="Escriba nombre para filtrar" style={{ width: "100%" }} value={filters.search} onChange={changeSearch} />
                        </div>
                        <div className='col-md-6 text-right'>
                            <button
                                className="btn btn-success"
                                onClick={handleShowCreate}
                            >
                                <i className="fas fa-plus" /> Asignar actividad
                            </button>
                        </div>
                    </div>
                    <div className='col-md-12'>
                        <Table
                            columns={columns}
                            data={results.rows}
                            tableClass="table table-striped separate"
                        />
                    </div>
                </div>
                <Paginations
                    total={results.count}
                    page={filters.page}
                    limit={filters.limit}
                    pageClick={paginationHandleClick}
                    showLimit={true}
                    limitOption={[10, 25, 100]}
                    limitChange={limitChange}
                />
            </div>
            <Modal show={showCreate} onHide={handleCloseCreate} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Asignar actividad</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="form-group">
                        <label for="descripcion">Actividad</label>
                        <AsyncTypeahead
                            id="typeaheadActividad"
                            labelKey="id_nombre"
                            multiple={false}
                            minLength={1}
                            onChange={handleSelectedActOnTypeahead}
                            isLoading={typeahead.isLoading}
                            filterBy={["nombre"]}
                            selectHintOnEnter={true}
                            clearButton={false}
                            searchText="Buscando..."
                            options={typeahead.options}
                            placeholder="Seleccionar actividad"
                            inputProps={{ className: "limit" }}
                            onSearch={(query) => searchActividad(query)}
                            renderMenuItemChildren={(option, props) => {
                                return <div key={option.id_actividad}>{option.id_nombre}</div>;
                            }}
                        />
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="success" onClick={createActCajas} disabled={!form.id_actividad}>
                        Guardar
                    </Button>
                </Modal.Footer>
            </Modal>
            <Modal show={showConfirm} onHide={handleCloseConfirm} centered>
                <Modal.Header>
                    <Modal.Title>Confirmación</Modal.Title>
                </Modal.Header>
                <Modal.Body>¿Estás seguro de querer eliminar esta relación a la actividad?</Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseConfirm}>
                        Cancelar
                    </Button>
                    <Button variant="primary" onClick={deleteActCajas}>
                        Aceptar
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
};

export default ActividadesCajas;
